/**
 * This class contains a few parts of stylesheets to be reused
 */
export default class StyleParts {
    static addConstructionWorksLayer(map, sourceId) {
        map.addLayer({
            "id": "edges-selected-highway-construction-black",
            "type": "line",
            "source": sourceId,
            "source-layer": "transportation",
            "maxzoom": 24,
            "paint": {
                "line-color": "rgba(12, 12, 12, 1)",
                "line-width": {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    /* @ts-ignore */
                    "base": 1.2,
                    "stops": [
                        [
                            15,
                            2
                        ],
                        [
                            20,
                            18
                        ]
                    ]
                }
            },
            filter: [
                "any",
                [
                    "all",
                    ["==", "$type", "LineString"],
                    ["in", "highway", "construction"],
                ]
            ],
        }, "symbol");
        map.addLayer({
            "id": "edges-selected-highway-construction",
            "type": "line",
            "source": sourceId,
            "source-layer": "transportation",
            "paint": {
                "line-color": "rgba(242, 255, 0, 1)",
                "line-width": {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    /* @ts-ignore */
                    "base": 1.2,
                    "stops": [
                        [
                            6.5,
                            0
                        ],
                        [
                            8,
                            0.4
                        ],
                        [
                            20,
                            10
                        ]
                    ]
                },
                "line-dasharray": [
                    2.5,
                    2
                ]
            },
            filter: [
                "any",
                [
                    "all",
                    ["==", "$type", "LineString"],
                    ["in", "highway", "construction"],
                ]
            ],
        }, "symbol");
    }
    static addRoadColorLayer(map, sourceId) {
        map.addLayer({
            "id": "anyways:roadcolor",
            "type": "line",
            "source": sourceId,
            "source-layer": "transportation",
            "paint": {
                "line-color": [
                    "case",
                    ["has", "anyways:color"],
                    ["get", "anyways:color"],
                    "rgba(255, 0, 0, 1)"
                ],
                "line-width": {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    /* @ts-ignore */
                    "base": 1.2,
                    "stops": [
                        [
                            6.5,
                            0
                        ],
                        [
                            8,
                            0.4
                        ],
                        [
                            20,
                            10
                        ]
                    ]
                },
            },
            filter: [
                "any", [
                    "all",
                    ["==", "$type", "LineString"],
                    ["has", "anyways:color"]
                ]
            ]
        }, "symbol");
    }
    static addDetoursLayer(map, sourceId) {
        map.addLayer({
            "id": "detour",
            "type": "line",
            "source": sourceId,
            "source-layer": "transportation",
            "paint": {
                "line-color": "#0000ff",
                "line-width": {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    /* @ts-ignore */
                    "base": 1.2,
                    "stops": [
                        [
                            6.5,
                            0
                        ],
                        [
                            8,
                            0.4
                        ],
                        [
                            20,
                            10
                        ]
                    ]
                },
            },
            filter: [
                "any",
                [
                    "all",
                    ["==", "$type", "LineString"],
                    ["in", "anyways:detour", "yes"],
                ]
            ],
        }, "symbol");
    }
    static addZonesLayer(map, sourceId) {
        map.addLayer({
            "id": "anyways:zones",
            "type": "fill",
            "source": sourceId,
            "source-layer": "transportation",
            "filter": [
                "all",
                ["has", "anyways:zone"]
            ],
            "paint": {
                "fill-color": [
                    "case",
                    ["has", "anyways:color"],
                    ["get", "anyways:color"],
                    "rgba(255, 0, 0, 1)"
                ],
                "fill-opacity": 0.5
            }
        }, "road");
    }
    static addCycleStreets(map, sourceId) {
        map.addLayer({
            "id": "cyclestreets",
            "type": "line",
            "source": sourceId,
            "source-layer": "transportation",
            "paint": {
                "line-color": "#6c4e4c",
                "line-opacity": 0.6,
                "line-width": {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    /* @ts-ignore */
                    "base": 1.2,
                    "stops": [
                        [
                            6.5,
                            0
                        ],
                        [
                            8,
                            0.4
                        ],
                        [
                            20,
                            10
                        ]
                    ]
                },
            },
            filter: [
                "any",
                [
                    "all",
                    ["==", "$type", "LineString"],
                    ["in", "cyclestreet", "yes"],
                ]
            ],
        }, "symbol");
    }
}
